var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'jeecg-form-container-disabled' : ''},[_c('fieldset',{attrs:{"disabled":_vm.disabled}},[_vm._t("detail")],2),_vm._t("edit"),_c('fieldset',{attrs:{"disabled":""}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }